import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, PATIENT_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchGetData = (get: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: get,
});
export const fetchData = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});




export const fetchCSData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,q:1};
            const apiname = PATIENT_API.patientreports_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchGetData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchACDData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,userid:uid};
            const apiname = PATIENT_API.patientreports_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


